import React from "react";
import {
  FormControl,
  FormControlLabel,
  Checkbox as MuiCheckbox,
} from "@mui/material";

function Checkbox(props) {
  const { name, label, value, onChange, style } = props;

  const convertToEventParam = (name, value) => ({
    target: {
      name,
      value,
    },
  });

  const styleDefault = { width: "100%", margin: "10px 0" };
  return (
    <FormControl sx={{ ...styleDefault, ...style }}>
      <FormControlLabel
        control={
          <MuiCheckbox
            name={name}
            color="primary"
            checked={value ? true : false}
            onChange={(e) =>
              onChange(convertToEventParam(name, e.target.checked))
            }
          />
        }
        label={label}
      />
    </FormControl>
  );
}

export default Checkbox;
